import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type MemberTimelineFilters = {
  itemTypeIn: string[]
}

type MemberTimelineFiltersStoreState = {
  memberTimelineFilters: MemberTimelineFilters
  setMemberTimelineFilters: (filters: MemberTimelineFilters) => void
}

export const useMemberTimelineFiltersStore = create<MemberTimelineFiltersStoreState>()(
  persist(
    set => ({
      memberTimelineFilters: { itemTypeIn: [] },
      setMemberTimelineFilters: filters =>
        set(() => ({
          memberTimelineFilters: {
            ...filters,
          },
        })),
    }),
    {
      name: 'memberTimelineFilters-storage',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
